import { api } from "@/lib/api";

// Sprint 11 — Finance summary + Expenses CRUD
export const FinanceAPI = {
  summary: (params) => api.get("/finance/summary", { params }).then((r) => r.data),
  categories: () => api.get("/finance/expense-categories").then((r) => r.data),
  listExpenses: (params) => api.get("/finance/expenses", { params }).then((r) => r.data),
  createExpense: (body) => api.post("/finance/expenses", body).then((r) => r.data),
  updateExpense: (id, patch) => api.patch(`/finance/expenses/${id}`, patch).then((r) => r.data),
  deleteExpense: (id) => api.delete(`/finance/expenses/${id}`).then((r) => r.data),
};
